<template>
  <div class="print-break-after">
    <!-- SHIPPING BOX TYPE -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Shipping box", "Scatola spedizione") }}
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="formData.shippingBoxType"
          >
            <option :value="undefined">{{
              $anm22.strLang(lang, "Select type", "Selezione tipologia")
            }}</option>
            <option
              v-for="(sbt, i) in shippingBoxTypes"
              :key="'sbt-' + i"
              :value="sbt.id"
              >{{ sbt.label }}</option
            >
          </select>
          <template v-else>
            <input
              v-if="
                shippingBoxTypes.find(
                  (sbt) => sbt.id === formData.shippingBoxType
                )
              "
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="
                shippingBoxTypes.find(
                  (sbt) => sbt.id === formData.shippingBoxType
                ).label
              "
            />
          </template>
        </div>
      </div>
    </div>
    <!-- NOTE -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Notes", "Note") }}
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <textarea
          :class="[
            'input-elem com-anm22-app-textarea',
            mode === 'view' ? 'stamp' : '',
          ]"
          style="height:100px;width:100%;max-width:unset;"
          v-model.lazy="formData.notes"
        ></textarea>
      </div>
    </div>
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Last edit", "Ultima modifica") }}
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ lastEditDate + " " + lastEditUser }}
        </div>
      </div>
    </div>
    <template v-if="mode === 'edit'">
      <div class="vertical-height-div" style="height:20px;"></div>
      <div class="wg-row">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, "Attachment", "Allegato") }}
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row finishing-images">
        <template v-if="formData.images">
          <div
            v-for="(img, index) in formData.images.filter((i) => i)"
            :key="'img-' + index"
            class="finishing-image"
          >
            <img
              class="image-preview"
              style="height:100%;width:100%;"
              :src="$anm22.icons.getWorldIcon('photoCamera')"
              @click="showPic(img)"
            />
            <img
              class="com-anm22-app-img-fixed-height-m delete-image-btn"
              :src="$anm22.icons.getWorldIcon('deleteBin')"
              @click="removeImage(index)"
            />
          </div>
        </template>
        <anm22-file-uploader
          :uploadUrl="
            'vircos/finishing-image?idWorldProject=' +
              this.project.idWorldProject
          "
          :onSuccess="addImage"
        ></anm22-file-uploader>
      </div>
    </template>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div v-if="mode === 'edit'" class="wg-row">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Save', 'Salva')"
        @click="saveForm"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Anm22FileUploader from "../../../../../../world/spa/components/Anm22FileUploaderInline.vue";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    mode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.formData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.formData.lastUpdate
        ? this.$moment.unix(this.formData.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    shippingBoxTypes() {
      return this.$anm22["vircos_getShippingBoxTypes"](this);
    },
  },
  methods: {
    saveForm() {
      const docs = { ...this.docs };
      docs.finishing = this.formData;
      docs.finishing.lastUser = this.user.idWorldUser;
      docs.finishing.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    showPic(img) {
      window.open(img, "_blank");
    },
    addImage(data) {
      if (!this.formData.images) {
        this.formData.images = [];
      }
      this.formData.images.push(data.url);
      const docs = { ...this.docs };
      docs.finishing = this.formData;
      docs.finishing.lastUser = this.user.idWorldUser;
      docs.finishing.lastUpdate = this.$moment().unix();
      this.$http
        .post(
          "vircos",
          {
            projectId: this.project.idWorldProject,
            docs: docs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData = response.data.docs.finishing;
        })
        .catch((error) => {
          /* offline */
        });
    },
    removeImage(index) {
      this.formData.images.splice(index, 1);
      const docs = { ...this.docs };
      docs.finishing = this.formData;
      docs.finishing.lastUser = this.user.idWorldUser;
      docs.finishing.lastUpdate = this.$moment().unix();
      this.$http
        .post(
          "vircos",
          {
            projectId: this.project.idWorldProject,
            docs: docs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData = response.data.docs.finishing;
        })
        .catch((error) => {
          /* offline */
        });
    },
  },
  created() {
    this.formData = { ...this.docs.finishing };
    if (this.formData.notes && Array.isArray(this.formData.notes)) {
      if (this.formData.notes.length > 0) {
        this.formData.notes = this.formData.notes[
          this.formData.notes.length - 1
        ].note;
      } else {
        this.formData.notes = "";
      }
    }
  },
  components: {
    Anm22FileUploader,
  },
};
</script>

<style lang="scss" scoped>
.input-row {
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
}
.input-elem {
  width: 200px;
  margin-bottom: 10px;
}
.stamp {
  height: 450px !important;
}

.finishing-images {
  .finishing-image {
    position: relative;
    height: 100px;
    width: 100px;
    margin: 5px;
    cursor: pointer;
    border: 1px solid #999;
    border-radius: 4px;

    .image-preview {
      padding: 20px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      object-fit: contain;
      opacity: 0.6;

      &:hover {
        opacity: 0.8;
      }
    }

    .delete-image-btn {
      position: absolute;
      top: 3px;
      right: 3px;
    }
  }
}
</style>
